// 引入首页
const Index = () => import(/* webpackChunkName: "Index" */ '../pages/Index')
// 引入用户页面
const routerConfig = [
  {
    path: '/',
    // name: 'index',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/introducePage',
    name: 'introducePage', // 介绍说明页 // 重量 保价 计泡
    component: () =>
      import(/* webpackChunkName: "Index" */ '../pages/Index/introducePage.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/businessPage/:index?',
    name: 'businessPage',
    component: () =>
      import(/* webpackChunkName: "Index" */ '../pages/Index/components/businessPage'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/introducePagev2',
    name: 'introducePagev2',
    component: () =>
      import(/* webpackChunkName: "Index" */ '../pages/IntroducePagev2/index'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/branchPage',
    name: 'branchPage',
    component: () =>
      import(/* webpackChunkName: "Index" */ '../pages/BranchPage/index'),
    meta: {
      keepAlive: true
    }
  }
]

export default routerConfig
